import React from 'react';
import Navigation from '@/components/shared/Navigation';
import Footer from '@/components/shared/Footer';

const Insights = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB] font-sans">
      <Navigation />

      {/* Header */}
      <section className="bg-white py-16 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-4xl font-semibold text-[#0A2540] mb-4">
            Insights
          </h1>
          <p className="text-xl text-[#2E2E2E] max-w-3xl">
            Analysis, perspectives, and structured thinking on lease abstraction
            and U.S. commercial real estate.
          </p>
        </div>
      </section>

      {/* Insights Content */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8">

            {/* Card 1 — 1031 Exchange */}
            <a
              href="/insights/1031-exchange-blueprint"
              className="block bg-white p-8 rounded-lg border border-gray-200 hover:border-[#4A6FA5] transition-colors"
            >
              <p className="text-sm text-gray-500 mb-2">
                Real Estate Strategy · PulseShift Research
              </p>

              <h3 className="text-xl font-semibold text-[#0A2540] mb-3">
                Mastering the 1031 Exchange
              </h3>

              <p className="text-[#2E2E2E] mb-4">
                How investors defer capital gains, preserve equity, and compound wealth through strategic exchanges.
              </p>

              <span className="text-[#4A6FA5] text-sm font-medium">
                Read analysis →
              </span>
            </a>

            {/* Card 2 — Stabilized Yield */}
            <a
              href="/insights/stabilized-yield-power"
              className="block bg-white p-8 rounded-lg border border-gray-200 hover:border-[#4A6FA5] transition-colors"
            >
              <p className="text-sm text-gray-500 mb-2">
                Real Estate Strategy · PulseShift Research
              </p>

              <h3 className="text-xl font-semibold text-[#0A2540] mb-3">
                Why Most Investors Miscalculate Success
              </h3>

              <p className="text-[#2E2E2E] mb-4">
                How Stabilized Yield separates institutional underwriting from snapshot-based investing.
              </p>

              <span className="text-[#4A6FA5] text-sm font-medium">
                Read analysis →
              </span>
            </a>

            {/* Card 3 — Cash-on-Cash */}
            <a
              href="/insights/cash-on-cash-yield-trap"
              className="block bg-white p-8 rounded-lg border border-gray-200 hover:border-[#4A6FA5] transition-colors"
            >
              <p className="text-sm text-gray-500 mb-2">
                Real Estate Strategy · PulseShift Research
              </p>

              <h3 className="text-xl font-semibold text-[#0A2540] mb-3">
                16.4% Return, Still a Bad Deal
              </h3>

              <p className="text-[#2E2E2E] mb-4">
                Why income-focused metrics like Cash-on-Cash can mask equity erosion and produce negative outcomes.
              </p>

              <span className="text-[#4A6FA5] text-sm font-medium">
                Read analysis →
              </span>
            </a>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Insights;
